import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, ModalController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';

import { Notes, Dokumen, Schedule } from '@providers/index';

import { DetailImagePage } from '../';

@Component({
  selector: 'page-form-note',
  templateUrl: 'page.html'
})
export class FormNotePage {

  form:any ={
    note            :'',
    dokument_id     :'',
    generated_name  :'',
    note_category_id:'',
    last_remark     :false
  };
  project:any = {};
  listCategory:any=[];
  loading:any;
  img_url='';
  

  constructor(
    public navCtrl     : NavController,
    public navParams   : NavParams,
    private toastCtrl  : ToastController,
    public loadingCtrl : LoadingController,
    public modalCtrl   : ModalController,
    public camera      : Camera,
    public notesApi    : Notes,
    public dokumenApi  : Dokumen,
    public scheduleApi : Schedule
  ) {
    this.project = this.navParams.get('project');
    this.img_url = this.dokumenApi.file_url;

    this.getCategory();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getCategory(){
    let params = {};
    this.scheduleApi.getActivityType(params).subscribe((resp:any) => {
      this.listCategory = resp.data;
    });
    console.log('note category => ', this.listCategory);
  }
 
  save(){    
    this.showLoading();

    let params = {
      note             : this.form.note,
      note_category_id : this.form.note_category_id,
      dokument_id      : this.form.dokument_id,
      project_id       : this.project.id,
      last_remark      : this.form.last_remark

    };
    this.notesApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.form.note = '';
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  takePicture(camera=1){
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth : 1024,
      sourceType:camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }


  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokumenApi.post(params).subscribe((resp:any) => {
      this.form.dokument_id=resp.data.id;
      this.form.generated_name=resp.data.generated_name;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  viewImage(generated_name) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.img_url+this.form.generated_name
    });
    profileModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/form_note/page.ts